<template>
    <div class="product">
        <h1>Product / Service</h1>
        <p>
            Products & Services are what your company actually delivers. They
            are realized by applications and belong to a certain domain.
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Product",
});
</script>
